import React, { Component } from "react"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import AsyncCreatableSelect from "react-select/lib/AsyncCreatable"
import { defineMessages, FormattedMessage, injectIntl } from "react-intl"
import Select from "react-select"

import GlobalHelper from "../common/GlobalHelper.jsx"

const messages = defineMessages({
    search_placeholder: {
        id: "customers.placeholder.email_selection.search_placeholder",
        defaultMessage: "Select or type an email..."
    }
})

/*  Attentions
 ** This component is deprecated, please use src/customer/email-selection/EmailSelectionComponent.tsx instead for new features
 */
class DeprecatedCustomerEmailSelect extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            selectedOptions: [],
            allowCreate: this.props.allowCreate || false,
            error: false,
            allowedEmails: this.props.allowedEmails || [],
            multi: !isNaN(this.props.multi) ? this.props.multi : true
        }
        const defaultCallback = () => {}
        this.name = this.props.name
        this.contactType = this.props.contactType || ""
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
        this.loadCustomers = this.loadCustomers.bind(this)
    }
    validateSelectedEmails(selectedOptions) {
        for (let option of selectedOptions) {
            if (option) {
                const value = option.value
                let email = value.substring(value.lastIndexOf("<") + 1, value.lastIndexOf(">"))
                if (!email) {
                    email = value
                }
                if (!GlobalHelper.validateEmail(email)) {
                    return false
                }
            }
        }
        return true
    }
    handleChange(selectedOptions) {
        if (!Array.isArray(selectedOptions)) {
            selectedOptions = [selectedOptions]
        }
        const error = !this.validateSelectedEmails(selectedOptions)
        this.setState(
            {
                selectedOptions: selectedOptions,
                error
            },
            () => {
                const options = this.state.selectedOptions || []
                this.onChange(
                    options.map(v => (v ? v.value : "")),
                    error
                )
            }
        )
    }
    handleBlur(event) {
        if (!event.target.value) {
            return
        }
        const options = this.state.selectedOptions
        options.push({
            value: event.target.value,
            label: event.target.value
        })
        this.setState({
            selectedOptions: options
        })
    }
    loadCustomers(input, callback) {
        AppContext.getApiClient()
            .post("/listing/search", {
                keywords: GlobalHelper.formatSearchKeywords(input),
                objects: ["contacts"],
                fields: ["name", "nameAnalyzed", "nameKeyword", "nameSort", "email", "emailKeyword"],
                filters: {
                    contactType: "persons"
                },
                pageSize: 50,
                activePage: 1,
                sortByField: "nameSort",
                sortAsc: true,
                lightResult: true
            })
            .then(response => {
                let opt = []
                for (let i in response.data) {
                    const p = response.data[i]
                    const values = this.getValuesFromRawEmail(
                        Array.isArray(p.email) ? p.email.join(",") : String(p.email),
                        p.name
                    )
                    opt = opt.concat(values)
                }
                callback(null, {
                    options: opt,
                    complete: false
                })
            })
    }
    getValuesFromRawEmail(raw, name) {
        let values = []
        let emails = []
        if (raw.includes(",")) {
            emails = raw.split(",")
        } else if (raw.includes(";")) {
            emails = raw.split(";")
        } else {
            emails.push(raw)
        }
        for (let x in emails) {
            const email = emails[x].trim()
            if (name) {
                values.push({
                    value: name + " <" + email + ">",
                    label: name + " <" + email + ">"
                })
            } else {
                values.push({
                    value: email,
                    label: email
                })
            }
        }
        return values
    }
    setInitialValue(value) {
        const values = value || []
        let opt = []
        for (let i in values) {
            opt = opt.concat(this.getValuesFromRawEmail(values[i]))
        }
        const error = !this.validateSelectedEmails(opt)
        this.setState(
            {
                selectedOptions: opt,
                error
            },
            () => {
                const options = this.state.selectedOptions || []
                this.onChange(
                    options.map(v => v.value),
                    error
                )
            }
        )
    }
    componentDidMount() {
        this.setInitialValue(this.props.value)
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.selectedOptions.length !== nextProps.value.length) {
            this.setInitialValue(nextProps.value)
        } else {
            this.setState({
                selectedOptions: nextProps.value.map(email => {
                    return { value: email, label: email }
                }),
                allowedEmails: nextProps.allowedEmails || []
            })
        }
    }
    render() {
        const selectedOptions = this.state.multi
            ? this.state.selectedOptions
            : this.state.selectedOptions && this.state.selectedOptions.length > 0
                ? this.state.selectedOptions[0]
                : null
        if (this.state.allowedEmails.length > 0) {
            return (
                <Select
                    name={this.name}
                    value={selectedOptions}
                    onChange={this.handleChange}
                    options={this.state.allowedEmails.map(email => {
                        return { value: email, label: email }
                    })}
                    multi={this.state.multi}
                />
            )
        }
        return (
            <AsyncCreatableSelect
                placeholder={this.props.intl.formatMessage(messages["search_placeholder"])}
                name={this.name}
                value={selectedOptions}
                onChange={this.handleChange}
                loadOptions={this.loadCustomers}
                onBlurResetsInput={true}
                onBlur={this.handleBlur}
                searchPromptText={this.props.intl.formatMessage(messages["search_placeholder"])}
                tabSelectsValue={false}
                multi={this.state.multi}
                clearable={this.state.clearable}
                promptTextCreator={newVal => {
                    return (
                        <FormattedMessage
                            id={"customers.placeholder.email_selection.create_new_option"}
                            defaultMessage='Add "{value}"'
                            values={{
                                value: newVal
                            }}
                        />
                    )
                }}
            />
        )
    }
}
export default injectIntl(DeprecatedCustomerEmailSelect)



// WEBPACK FOOTER //
// ./src/customer/emailselection.component.jsx